const c = "_fieldContainer_1czhz_1", n = "_disabled_1czhz_10", t = "_textField_1czhz_14", e = "_compact_1czhz_23", a = "_leadingIcon_1czhz_26", o = "_trailingIcon_1czhz_29", _ = "_regular_1czhz_57", i = {
  fieldContainer: c,
  "container-regular": "_container-regular_1czhz_4",
  "container-compact": "_container-compact_1czhz_7",
  disabled: n,
  textField: t,
  compact: e,
  leadingIcon: a,
  trailingIcon: o,
  regular: _
};
export {
  e as compact,
  i as default,
  n as disabled,
  c as fieldContainer,
  a as leadingIcon,
  _ as regular,
  t as textField,
  o as trailingIcon
};
//# sourceMappingURL=TextFieldMask.module.scss.js.map
